import { CardPreviewCard } from 'apps/shared/scripts/components';

import { FormValues } from '../OnboardingForm';

import {
  browserClassName,
  cardPreviewClassName,
  containerClassName,
} from './styles';

interface Props {
  formValues: FormValues;
}

const CardPreview = ({ formValues }: Props) => {
  return (
    <div className={cardPreviewClassName}>
      <div className={containerClassName}>
        <div className={browserClassName}>
          <CardPreviewCard desktop {...formValues} />
        </div>
      </div>
    </div>
  );
};

CardPreview.displayName = 'CardPreview';

export default CardPreview;
